/**
 * Dashboard Tabs Component
 *
 * Handles the main tab selection for the dashboard.
 */

import React from 'react';
import { SelectionBar } from '../../UI/V3/SelectionBar/SelectionBar';
import { DASHBOARD_TABS } from '../constants/DashboardData';
import type { DashboardTab } from '../types/DashboardTypes';
import styles from '../DashboardComponent.module.scss';

interface DashboardTabsProps {
    selectedTab: DashboardTab;
    onTabChange: (tab: DashboardTab) => void;
}

export const DashboardTabs: React.FC<DashboardTabsProps> = ({ selectedTab, onTabChange }) => {
    const handleTabSelect = (id: string) => {
        onTabChange(id as DashboardTab);
    };

    return (
        <div className={styles.tabsSection}>
            <SelectionBar
                options={DASHBOARD_TABS}
                selectedId={selectedTab}
                onSelect={handleTabSelect}
                className={styles.selectionBar}
            />
        </div>
    );
};
